exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".place-area-name[data-v-10cfb82d]{font-size:46px;line-height:1;fill:#333;white-space:pre;color:#fff;font-weight:700;display:inline-block}", ""]);
